<script lang="ts">
    import FeatherIcon from "svelte-feather-icon";
    import { Image } from "sveltestrap";
    export let socialItem
    let imgPath:string = "/assets/images"
</script>
<div class="new-users-social">
    <div class="media">
        <Image class="rounded-circle image-radius m-r-15" src="{imgPath}/{socialItem.img}" alt="" />
        <div class="media-body">
            <h6 class="mb-0 f-w-700">{socialItem.name}</h6>
            <p>{socialItem.date}</p>
        </div>
        <span class="pull-right mt-0">
            <FeatherIcon icon={socialItem.icon} />
        </span>
    </div>
</div>
<Image fluid alt="" src="{imgPath}/{socialItem.img2}"/>